import React, { Component } from "react";
import "./TaxJarViewNexusRegions.scss";
import IErrorDTO from "../../../../../models/DTO/IErrorDTO";
import ITaxJarNexusRegionsDTO from "../../../../../models/DTO/ITaxJarNexusRegionsDTO";
import ITaxJarOnGetNexusRegionsDTO from "../../../../../models/DTO/ITaxJarOnGetNexusRegionsDTO";
import EndpointsEnum from "../../../../../models/EndpointsEnum";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUserUI";
import ITaxJarNexusRegion from "../../../../../models/TaxJar/ITaxJarNexusRegion";
import OwButton from "../../../../shared/OwButton/OwButton";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import OwTitle from "../../../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
};

type State = {
    regions: ITaxJarNexusRegion[];
};

class TaxJarViewNexusRegions extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            regions: [],
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.TaxJarOnGetNexusRegions, this.onGetNexusRegions);

        this.getNexusRegions();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.TaxJarOnGetNexusRegions, this.onGetNexusRegions);
    }

    getNexusRegions = () => {
        const payload: ITaxJarNexusRegionsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.TaxJarGetNexusRegions, payload);
    };

    onGetNexusRegions = (data: ITaxJarOnGetNexusRegionsDTO) => {
        this.setState({
            regions: data.regions,
        });
    };

    closeModal = () => {
        this.props.closeModalFn();
    };

    create = () => {};

    render() {
        return (
            <div className={"TaxJarViewNexusRegions p-2"}>
                <div className={"w-100"}>
                    <div className={"d-flex justify-content-between"}>
                        <OwTitle leftIconName={"fad fa-eye"} title={"taxjar_nexus_regions"} tag={"h3"} />
                        <div>
                            <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.closeModal} />
                        </div>
                    </div>
                </div>

                <div className={"mt-3"}>
                    <OwLabel title={"manage_nexus_regions"} className={"me-2"} postText={":"} />
                    <a href={"https://app.taxjar.com/account#states"} target={"_blank"} rel="noreferrer">
                        https://app.taxjar.com/account#states
                    </a>
                </div>

                <div className={"mt-3"}>
                    {this.state.regions.map((region) => {
                        return (
                            <div key={`${region.country_code}-${region.region}`}>
                                {region.country_code} - {region.region}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default TaxJarViewNexusRegions;
